module.exports = __webpack_public_path__ + "img/yanguankaohe.1f8ef77e.png";